import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Button, Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { removeUnderscores } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { CollateralEvaluationTableColumns } from "assets/properties/properties";
import ViewDetailsLink from "./SendBackDetails/ViewDetailsLink";
import StageHistoryModal from "./SendBackDetails/StageHistoryModal";

const CollateralEvaluationApproval = ({ seletedBranchCode, featureFlags }) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [branchCodeList, setBranchCodeList] = useState([]);
  const filteredOnlyDeviationTrueCollateralEvaluation = parseAndSetFlag(featureFlags?.filteredOnlyDeviationTrueCollateralEvaluation);
  const [stageHistoryModal, setStageHistoryModal] = useState(false);
    const [selectedLeadId, setSelectedLeadId] = useState(null);
      const enabledSendBackStageDetails = parseAndSetFlag(
      featureFlags?.enabledSendBackStageDetails
    );
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
 useEffect(() => {
    getAllBranchDetails();
  }, []);
  const getAllBranchDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_ALL_BRANCH,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setBranchCodeList(result?.data);
      GetData(result?.data);
    }
  };

  const GetData = async (branchList) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.COLLATERAL_EVALUATION_SEARCH,
      authToken: authToken,
      method: "GET",
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      parseIndicatorData(result?.data,branchList);
    }
  };

  const parseIndicatorData = (data,branchList) => {
    let reportData = [];
    data = data?.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
     const matchBranchName = (branchCode) => {
    const branch = branchList.find((branch) => branch.code === branchCode);
      return branch ? branch.name : branchCode;
    }
    if(filteredOnlyDeviationTrueCollateralEvaluation){
      data = data?.filter( item => item.deviation)
    }
    data &&
      data.forEach((ForApprovalApplication, index) => {
        let row = {
          applicationid: ForApprovalApplication.loanApplicationId,
          created: ForApprovalApplication.createdBy,
          formNumber: ForApprovalApplication.loanApplicationNumber,
          accountNumber: ForApprovalApplication.loanAccountNumber,
          customerid: ForApprovalApplication.customerId,
          customerName: ForApprovalApplication.customerName,
          branchName: matchBranchName(ForApprovalApplication?.branchCode),
          mobile: ForApprovalApplication.mobileNumber?.trim(),
          level: ForApprovalApplication.pendingApprovalLevel,
          mandatory: ForApprovalApplication.pendingApprovalMandatory,
          productType: ForApprovalApplication?.productType,
          type: `${removeUnderscores(
            ForApprovalApplication?.applicationType
          )} / ${removeUnderscores(
            ForApprovalApplication?.applicationSubType
          )}`,
          ...(enabledSendBackStageDetails
        ? {
            stageHistory: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {Number(
                  ForApprovalApplication?.applicationStageHistoryCount
                ) > 0 && (
                  <ViewDetailsLink
                    onClick={() => {
                      setSelectedLeadId(
                        ForApprovalApplication?.loanApplicationId
                      );
                      setStageHistoryModal(true);
                    }}
                  />
                )}
              </div>
            ),
          }
        : {}),
          // action:GetAction(
          //   ForApprovalApplication.loanApplicationId,
          //   ForApprovalApplication.loanApplicationNumber,
          // ),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const GetAction = (loanApplicationId, loanApplicationNumber) => {
    return (
      <>
        <Button
          aria-label="Edit Branch"
          onClick={() =>
            onClickUpdateData(loanApplicationId, loanApplicationNumber)
          }
        >
          Proceed
        </Button>
      </>
    );
  };
  const onClickUpdateData = async (
    loanApplicationId,
    loanApplicationNumber,
    loanAccountNo,
    level,
    mandatory,
    productType
  ) => {
    const result = await apiHandler({
      url: endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}`,
      authToken: authToken,
    });
     const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
      const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]
    const navigationData = {
      loanApplicationId,
      loanAccountNo,
      status: "COLLATERALEVALUATION",
      subStatus: result?.data?.applicationSubType || "",
      prePledgeLoan: prepledgeLoanAccountNumber || "",
      editable: false,
      loanType: result?.data?.applicationType || "",
      level,
      mandatory,
      seletedBranchCode,
      prepledgeLoanMap:prepledgeLoanMap,
      productType,
    };
    navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };
const tableColumns = enabledSendBackStageDetails
  ? [
      ...CollateralEvaluationTableColumns,
      { id: "stageHistory", label: "Stage History" },
    ]
  : CollateralEvaluationTableColumns;
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={featureFlags?.changeColleteralEvaluationTabName}
          onlyLabel
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={tableColumns}
          rows={selectedTableData}
          onClickUpdateData={onClickUpdateData}
          flag="collateralEvaluation"
        />
      </Grid>
       <StageHistoryModal
      open={stageHistoryModal}
      onClose={() => {
        setStageHistoryModal(false);
        setSelectedLeadId(null);
      }}
      leadId={selectedLeadId}
      authToken={authToken}
    />
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

CollateralEvaluationApproval.propTypes = {
  classes: PropTypes.object,
};

export default CollateralEvaluationApproval;
